// C4 Sticky ATC mobile — v2 more stable visibility logic
(function () {
  if (window.innerWidth >= 750) return;

  var sticky = document.querySelector('.sticky-atc-mobile');
  if (!sticky) return;

  var mainAtc =
    document.querySelector('product-form .product-form__submit') ||
    document.querySelector('[name="add"]') ||
    document.querySelector('.product-form__buttons button[type="submit"]');

  if (!mainAtc) return;

  // Keep the mobile bar visible while browsing the product page.
  sticky.setAttribute('data-visible', 'true');

  // sticky button click handler
  var btn = sticky.querySelector('[data-sticky-atc-action]');
  if (!btn) return;
  var originalLabel = btn.textContent.trim();

  btn.addEventListener('click', function (e) {
    e.preventDefault();
    var actionType = sticky.getAttribute('data-action-type');
    if (actionType === 'choose') {
      var variantPicker =
        document.querySelector('variant-selects, variant-radios, fieldset.product-form__input');
      if (variantPicker) {
        variantPicker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    // Fire the actual add-to-cart immediately (no scroll, no freeze)
    // Prefer form.requestSubmit() so product-form.js AJAX handler takes over
    var form = mainAtc.closest('form[action*="/cart/add"]') || mainAtc.closest('form');
    btn.disabled = true;
    btn.textContent = 'Ajout…';
    var restoreTimer = null;
    function restore(label) {
      btn.disabled = false;
      btn.textContent = label || originalLabel;
    }
    try {
      if (form && typeof form.requestSubmit === 'function') {
        form.requestSubmit(mainAtc);
      } else if (form) {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      } else {
        mainAtc.click();
      }
    } catch (err) {
      mainAtc.click();
    }
    // quick visual feedback → revert after 1.2s (cart drawer opens meanwhile)
    restoreTimer = setTimeout(function () { restore('✓ Ajouté'); }, 600);
    setTimeout(function () {
      clearTimeout(restoreTimer);
      restore(originalLabel);
    }, 2000);
  });
})();
